var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99943 12.0006C11.9294 12.0007 13.4996 10.4309 13.4997 8.50086C13.4999 6.57086 11.93 5.00073 10 5.00057C8.07 5.00042 6.49987 6.57029 6.49971 8.50029C6.49955 10.4303 8.06943 12.0004 9.99943 12.0006ZM2.999 17.25C2.99919 14.92 7.65928 13.7504 9.99928 13.7506C12.3393 13.7508 16.9992 14.9211 16.999 17.2511L16.9989 19.0011L2.99885 19L2.999 17.25ZM9.99912 15.7506C8.20912 15.7504 6.17906 16.4203 5.33902 17.0002L14.659 17.001C13.8191 16.4209 11.7891 15.7507 9.99912 15.7506ZM11.4997 8.5007C11.4998 7.6707 10.8298 7.00064 9.99984 7.00057C9.16984 7.00051 8.49978 7.67045 8.49971 8.50045C8.49965 9.33045 9.16959 10.0005 9.99959 10.0006C10.8296 10.0006 11.4996 9.3307 11.4997 8.5007ZM17.0393 13.8112C18.1992 14.6512 18.9991 15.7713 18.999 17.2513L18.9989 19.0013L22.9989 19.0016L22.999 17.2516C22.9992 15.2316 19.4993 14.0814 17.0393 13.8112ZM19.4997 8.50135C19.4996 10.4314 17.9294 12.0012 15.9994 12.0011C15.4594 12.001 14.9594 11.871 14.4995 11.6509C15.1295 10.761 15.4996 9.67102 15.4997 8.50102C15.4998 7.33102 15.1299 6.24099 14.5 5.35094C14.96 5.13098 15.46 5.00102 16 5.00107C17.93 5.00122 19.4999 6.57135 19.4997 8.50135Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople24Px);
export default __webpack_public_path__ + "static/media/people_24px.4f24ce1e2845b6595b19244c0b44ce9c.svg";
export { ForwardRef as ReactComponent };